import { ReactElement } from 'react';
import { ColumnLayout } from '../../../../modules/common/layouts/columnLayout/ColumnLayout';
import { UsersFormContainer } from '../../../modules/projectDetails/containers/UsersForm.container';
import { UsersListContainer } from '../../../modules/projectDetails/containers/UsersList.container';

export const ProjectDetailsCollaboratorsView = (): ReactElement => (
  <ColumnLayout size='l'>
    <ColumnLayout size='md'>
      <UsersFormContainer />
      <UsersListContainer />
    </ColumnLayout>
  </ColumnLayout>
);
